import { API_PDC_URL_V1, APP_PDC_URL } from "../../../config";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";

export const detailConstants = {
  GET_SUBJECTIVE_FOLDER_DETAIL_START: "GET_SUBJECTIVE_FOLDER_DETAIL_START",
  GET_SUBJECTIVE_FOLDER_DETAIL_SUCCESS: "GET_SUBJECTIVE_FOLDER_DETAIL_SUCCESS",
  GET_SUBJECTIVE_FOLDER_DETAIL_ERROR: "GET_SUBJECTIVE_FOLDER_DETAIL_ERROR",

  GET_SUBJECTIVE_FOLDER_DETAIL_CONTENT_START: "GET_SUBJECTIVE_FOLDER_DETAIL_CONTENT_START",
  GET_SUBJECTIVE_FOLDER_DETAIL_CONTENT_SUCCESS: "GET_SUBJECTIVE_FOLDER_DETAIL_CONTENT_SUCCESS",
  GET_SUBJECTIVE_FOLDER_DETAIL_CONTENT_ERROR: "GET_SUBJECTIVE_FOLDER_DETAIL_CONTENT_ERROR",

  UPDATE_ATTACHMENTS_DETAIL_START: "UPDATE_ATTACHMENTS_FOLDER_DETAIL_START",
  UPDATE_ATTACHMENTS_DETAIL_SUCCESS: "UPDATE_ATTACHMENTS_DETAIL_SUCCESS",
  UPDATE_ATTACHMENTS_DETAIL_ERROR: "UPDATE_ATTACHMENTS_FOLDER_DETAIL_ERROR",

  GET_PREVIEW_FOLDER_DOCUMENT_START: "GET_PREVIEW_FOLDER_DOCUMENT_START",
  GET_PREVIEW_FOLDER_DOCUMENT_SUCCESS: "GET_PREVIEW_FOLDER_DOCUMENT_SUCCESS",
  GET_PREVIEW_FOLDER_DOCUMENT_ERROR: "GET_PREVIEW_FOLDER_DOCUMENT_ERROR",

  GET_FOLDER_DOCUMENT_START: "GET_FOLDER_DOCUMENT_START",
  GET_FOLDER_DOCUMENT_SUCCESS: "GET_FOLDER_DOCUMENT_SUCCESS",
  GET_FOLDER_DOCUMENT_ERROR: "GET_FOLDER_DOCUMENT_ERROR",

  CLEAR_SUBJECTIVE_FOLDER_DETAIL: "CLEAR_SUBJECTIVE_FOLDER_DETAIL",
  CLEAR_SUBJECTIVE_FOLDER_PREVIEW: "CLEAR_SUBJECTIVE_FOLDER_PREVIEW",
  GET_FOLDER_DOWNLOAD_START: "GET_FOLDER_DOWNLOAD_START",
  GET_FOLDER_DOWNLOAD_SUCCESS: "GET_FOLDER_DOWNLOAD_SUCCESS",
  GET_FOLDER_DOWNLOAD_ERROR: "GET_FOLDER_DOWNLOAD_ERROR"
};

export function loadFolderDocumentPreview(idAttachment, page) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const accountantIdSelected = getState().main.accountantIdSelected;
    const clientIdSelected = getState().main.clientIdSelected;
    const request = {
      method: "get",
      url: APP_PDC_URL + `/v2/documents/${idAttachment}/preview/${page || 1}?itemId=${clientIdSelected}&accountantId=${accountantIdSelected}`,
      headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: detailConstants.GET_PREVIEW_FOLDER_DOCUMENT_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then((res) => {
          if (res.status === 200) {
            dispatch({
              type: detailConstants.GET_PREVIEW_FOLDER_DOCUMENT_SUCCESS,
              payload: {
                content: res.data.content
              }
            });
          } else {
            dispatch({
              type: detailConstants.GET_PREVIEW_FOLDER_DOCUMENT_ERROR,
              error: res
            });
          }
          resolve(res.data);
        })
        .catch((response) => {
          dispatch({
            type: detailConstants.GET_PREVIEW_FOLDER_DOCUMENT_ERROR,
            error: response
          });
          reject(response);
        });
    });
  };
}

export function loadFolderDocument(idAttachment) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const accountantIdSelected = getState().main.accountantIdSelected;
    const clientIdSelected = getState().main.clientIdSelected;
    let request = {
      method: "get",
      url: APP_PDC_URL + `/v2/documents/${idAttachment}?itemId=${clientIdSelected}&accountantId=${accountantIdSelected}`,
      headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
    };
    return new Promise(function(resolve, reject) {
      dispatch({
        type: detailConstants.GET_FOLDER_DOCUMENT_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then((res) => {
          if (res.status === 200) {
            dispatch({
              type: detailConstants.GET_FOLDER_DOCUMENT_SUCCESS,
              payload: res.data
            });
          } else {
            dispatch({
              type: detailConstants.GET_FOLDER_DOCUMENT_ERROR,
              error: res
            });
          }
          resolve(res.data);
        })
        .catch((response) => {
          dispatch({
            type: detailConstants.GET_FOLDER_DOCUMENT_ERROR,
            error: response
          });
          reject(response);
        });
    });
  };
}

export function loadFolderDetail(idFolder) {
  return (dispatch, getState) => {
    const auth = getState().auth;

    const request = {
      method: "get",
      url: API_PDC_URL_V1 + `/folders/${idFolder}`,
      headers: {
        ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      }
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then((res) => {
          if (res.status === 200) {
            dispatch({
              type: detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_SUCCESS,
              payload: res.data
            });
          } else {
            dispatch({
              type: detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_ERROR,
              error: res
            });
          }
          resolve(res.data);
        })
        .catch((response) => {
          dispatch({
            type: detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_ERROR,
            error: response
          });
          reject(response);
        });
    });
  };
}

export function loadFolderDetailContent(idFolder) {
  return (dispatch, getState) => {
    const auth = getState().auth;

    const request = {
      method: "get",
      url: API_PDC_URL_V1 + `/folders/${idFolder}/content`,
      headers: {
        ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      }
    };
    return new Promise(function(resolve, reject) {
      dispatch({
        type: detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_CONTENT_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then((res) => {
          if (res.status === 200) {
            dispatch({
              type: detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_CONTENT_SUCCESS,
              payload: res.data
            });
          } else {
            dispatch({
              type: detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_CONTENT_ERROR,
              error: res
            });
          }
          resolve(res.data);
        })
        .catch((response) => {
          dispatch({
            type: detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_CONTENT_ERROR,
            error: response
          });
          reject(response);
        });
    });
  };
}

export function clearFolderDetail() {
  return function(dispatch) {
    dispatch({
      type: detailConstants.CLEAR_SUBJECTIVE_FOLDER_DETAIL
    });
  };
}

export function clearFolderPreview() {
  return function(dispatch) {
    dispatch({
      type: detailConstants.CLEAR_SUBJECTIVE_FOLDER_PREVIEW
    });
  };
}

export function downloadFolder(idFolder) {
  return (dispatch, getState) => {
    const auth = getState().auth;

    return new Promise((resolve, reject) => {
      let request = {
        method: "get",
        url: `${API_PDC_URL_V1}/folders/${idFolder}/download`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: detailConstants.GET_FOLDER_DOWNLOAD_START,
        payload: { id: idFolder }
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 403) {
            reject();
          } else {
            if (result.data._embedded) {
              dispatch({
                type: detailConstants.GET_FOLDER_DOWNLOAD_SUCCESS,
                payload: result.data._embedded
              });
              resolve(result.data._embedded);
            } else {
              dispatch({
                type: detailConstants.GET_FOLDER_DOWNLOAD_ERROR,
                error: result.data
              });
              reject();
            }
          }
        })
        .catch((response) => {
          dispatch({
            type: detailConstants.GET_FOLDER_DOWNLOAD_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}
